import { Injectable } from '@angular/core';
import { PlaySectionName, ValidationStateService } from '@r1-compass-library/features/validation-sync';
import { AppConstants } from '../app.constants';
import { Play } from '@r1-compass-library/models';

// Note - this was extracted out of the service below for a feature which was
// rolled back: https://support.relationshipone.com/a/tickets/15388
// We may revisit this in the future and re-use this. For now, it is fine here.
function determinePlayValidity(
    type: PlaySectionName,
    play: Partial<Play>,
    invalidSections: PlaySectionName[]
): boolean {
    const anyPlaySectionInvalid = invalidSections.length > 0;

    if (anyPlaySectionInvalid) {
        return false;
    }

    const hasOtherSectionsByType: Record<PlaySectionName, boolean> = {
        definition: Boolean(
            play.config?.talkingPointsDefinition && (play.config.criteria || play.config.playFileImport)
        ),
        recordSelection: Boolean(play.config?.talkingPointsDefinition && play.config.definition),
        talkingPoints: Boolean(play.config?.definition && (play.config.criteria || play.config.playFileImport)),
        scheduling: Boolean(
            play.config?.definition &&
                play.config?.talkingPointsDefinition &&
                (play.config.criteria || play.config.playFileImport)
        ),
    };

    return hasOtherSectionsByType[type];
}

@Injectable({ providedIn: 'root' })
export class PlayValidationStateService extends ValidationStateService<PlaySectionName> {
    constructor() {
        super(AppConstants.PlaysComponent.children, true);
    }

    public determinePlayValidity(type: PlaySectionName, play: Partial<Play>): boolean {
        return determinePlayValidity(type, play, this.invalidSections());
    }
}
